import NavBar from "@/components/navbar/NavBar";
import NavBarModernClean from "@/components/navbar/NavBarModernClean";
import NavBarPosterBold from "@/components/navbar/NavBarPosterBold";
import BigBoldBanner from "@/components/banner/BigBoldBanner";
import ModernCleanBanner from "@/components/banner/ModernCleanBanner";
import TraditionalBanner from "@/components/banner/TraditionalBanner";
import ModernCleanFooter from "@/components/footer/ModernCleanFooter";
import PosterBoldFooter from "@/components/footer/PosterBoldFooter";

export const navbarComponentMap = {
  standardNavBar: NavBar,
  modernCleanNavBar: NavBarModernClean,
  posterBoldNavBar: NavBarPosterBold,
};

export type NavBarType = keyof typeof navbarComponentMap;

export type BannerStyle = "bigBold" | "modernClean" | "traditional";

const bannerStyleMap = {
  bigBold: BigBoldBanner,
  modernClean: ModernCleanBanner,
  traditional: TraditionalBanner,
};

interface ComponentConfig {
  name: string;
}

export const getNavBarComponent = (components: ComponentConfig[] | null): { name: NavBarType } => {
  const found = components?.find(component => component.name.includes("NavBar"));
  if (found?.name && found.name in navbarComponentMap) {
    return { name: found.name as NavBarType };
  }
  return { name: "modernCleanNavBar" };
};

export const getFooterComponent = (navbarType: NavBarType) => {
  // Match footer style to navbar style; default to ModernClean for every
  // family that doesn't ship a dedicated footer.
  if (navbarType?.includes("posterBold")) {
    return PosterBoldFooter;
  }
  return ModernCleanFooter;
};

export const getBannerComponent = (navbarType: NavBarType, forceBannerStyle?: BannerStyle) => {
  // Check for forced banner style (used in Storybook)
  if (forceBannerStyle) {
    return bannerStyleMap[forceBannerStyle];
  }

  // Match banner style to navbar style
  if (navbarType?.includes("BigBold")) {
    return BigBoldBanner;
  }
  if (navbarType?.includes("Traditional")) {
    return TraditionalBanner;
  }
  return ModernCleanBanner;
};
